import React, { useState } from "react";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from "moment";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import './date-picker.scss'

// Use the basic <TimePicker /> (responsive digital list / lighter digital clock)
// for all browsers. MUI X's MobileTimePicker analog clock stutters on Safari and
// is inconsistent with the rest of the form inputs.

export default function TimePickerInput({ maxDate, disabled, label, placeholder, required, validation = [], value, onChange, error, touched, dataCy = "", ...props }) {
    let isRequired = required || (validation.includes('required') && !(validation.includes('skip') || validation.includes('optional')));

    // Controlled open state removes the open button and lets the whole input
    // field open the popper on click.
    const [open, setOpen] = useState(false);

    const pickerSpecificProps = {
        open,
        onClose: () => setOpen(false),
        disableOpenPicker: true,
        slotProps: {
            popper: { disablePortal: true, shouldRestoreFocus: false, style: { zIndex: 1400 } },
            paper: { style: { minWidth: 320, maxWidth: 'none' } },
            field: { onClick: () => setOpen(true) }
        }
    };

    const Picker = TimePicker;

    return (
        <div className="form-group">
            <div className="input-block datepicker-block" data-cy={dataCy}>
                <span className="input-icon icon-grey"><AccessTimeIcon /></span>
                <label className="input-label">
                    <span>{label || placeholder || ''} {isRequired ? <span className='text-danger'>*</span> : null}</span>
                </label>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Picker
                        id={props.name}
                        margin='dense'
                        inputVariant='outlined'
                        value={moment.utc(value)}
                        onChange={(value) => onChange(moment(value).toISOString())}
                        disabled={disabled}
                        {...pickerSpecificProps}
                        {...props}
                    />
                </LocalizationProvider>
                <br />
                {touched && error && <span style={{ color: 'red' }}>{error}</span>}
            </div>
        </div>
    );
}
